import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down",
  "use": "arrow-down-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol viewBox=\"0 0 15 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-down\">\n<path d=\"M7.5 11.75C7.3081 11.75 7.1161 11.6768 6.96985 11.5303L2.46985 7.03027C2.17688 6.7373 2.17688 6.2627 2.46985 5.96973C2.76282 5.67676 3.23743 5.67676 3.5304 5.96973L7.5 9.94062L11.4703 5.97031C11.7633 5.67734 12.2379 5.67734 12.5309 5.97031C12.8238 6.26328 12.8238 6.73789 12.5309 7.03086L8.03086 11.5309C7.88438 11.6773 7.69219 11.75 7.5 11.75Z\" fill=\"#7680A1\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol